// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media screen and (min-width: 1285px) {\n.customScrollDoc[data-v-2a06fbd4] {\n    height: 305px;\n}\n.customScrollDocManager[data-v-2a06fbd4]{\n    height: 140px;\n}\n.customScrollDocProj[data-v-2a06fbd4]{\n    height: 350px;\n}\n.handleOverflow[data-v-2a06fbd4] {\n    word-wrap: break-word;\n    max-width: 218px;\n}\n}\n.document-section .fileNameRow[data-v-2a06fbd4] {\n  max-width: 224px;\n  word-wrap: break-word;\n}\n", ""]);
// Exports
module.exports = exports;
